import React from "react";
import {graphql} from "react-apollo";
import {flowRight as compose} from "lodash";
import {FieldArray, reduxForm} from "redux-form/immutable";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {fromJS, List} from "immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import FormError from "../../../components/forms/FormError";
import LinesField, {orderableProducts, filledLines} from "./LinesField";
import {cancelEditPurchaseOrderLines, successEditPurchaseOrderLines} from "../../../actions/PurchaseOrderApiActions";
import {LIST_PRODUCTS} from "../../../queries/inventory";
import {GET_PURCHASE_ORDER} from "../../../queries/purchaseOrders";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";

const LinesForm = reduxForm({form: "PurchaseOrderLinesForm"})((props) => {
  const label = props.submitting ? "Standby..." : "Save Lines";
  return (
    <form onSubmit={props.handleSubmit}>
      <div className="fields">
        <FormFieldsTable>
          <FieldArray name="lines" component={LinesField} props={{products: props.products}} />
        </FormFieldsTable>
      </div>
      <FormError error={props.errors._error} />
      <div className="buttons">
        <ActionButton label={label} onClick={props.submit} active={!props.submitting} />
        <ActionButton label="Cancel" active={!props.submitting} onClick={props.onCancel} />
      </div>
    </form>
  )
});

// Replaces the lines of a draft purchase order.
class PurchaseOrderLinesFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const data = {purchaseOrderId: this.props.purchaseOrderId, lines: filledLines(values.get("lines", List())).toJS()};
    return this.props.setPurchaseOrderLines(data)
      .then((response) => {
        const errors = response.data.setPurchaseOrderLines.errors;
        if (errors.length <= 0) this.props.successEditPurchaseOrderLines();
        else this.setState({errors: createValidationErrors(errors, errors.map((error) => error.message).join("\n"))});
      })
      .catch((err) => this.setState({errors: createErrors(err)}));
  }

  render() {
    const {productsData, orderData} = this.props;
    for (const data of [productsData, orderData]) {
      if (data.loading) return <Loading />
      if (data.error) return <GraphQLErrors error={data.error} />
    }
    const lines = (orderData.purchaseOrder.lines || []).map(({sku, quantity}) => ({sku, quantity}));

    return (
      <LinesForm
        initialValues={fromJS({lines})}
        products={orderableProducts(fromJS(productsData.products || []))}
        errors={this.state.errors}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={() => this.props.cancelEditPurchaseOrderLines()}
        />
    )
  }
}

const SET_PURCHASE_ORDER_LINES = gql`
  mutation setPurchaseOrderLines($data: SetPurchaseOrderLinesInput!) {
    setPurchaseOrderLines(input: $data) {
      errors { key message }
    }
  }
`;

const withData = compose(
  graphql(LIST_PRODUCTS, {name: "productsData", options: () => ({fetchPolicy: "network-only", variables: {}})}),
  graphql(GET_PURCHASE_ORDER, {name: "orderData", options: (props) => ({fetchPolicy: "network-only", variables: {id: props.purchaseOrderId}})}),
  graphql(SET_PURCHASE_ORDER_LINES, {props: ({mutate}) => ({setPurchaseOrderLines: (data) => mutate({variables: {data}})})}),
);

export default connect(null, {cancelEditPurchaseOrderLines, successEditPurchaseOrderLines})(withData(PurchaseOrderLinesFormContainer));
